export default __webpack_public_path__ + "static/media/amenity-4.acd19d8b.jpg";